// // lib/audio/beeper.ts

// // Local waveform type (avoids depending on DOM lib for OscillatorType)
// type OscType = 'sine' | 'square' | 'sawtooth' | 'triangle';

// let ctx: AudioContext | undefined;
// let lastBeepAt = 0;

// function ensureCtx(): AudioContext {
//   if (!ctx) {
//     const AC: any = (window as any).AudioContext || (window as any).webkitAudioContext;
//     ctx = new AC() as AudioContext;
//   }
//   return ctx;
// }

// /** Call on a user gesture (mousedown/click/touchstart) before trying to play audio */
// export async function unlockAudio(): Promise<void> {
//   try {
//     const c = ensureCtx();
//     if (c.state !== 'running') {
//       await c.resume();
//     }
//   } catch {
//     /* noop */
//   }
// }

// export type BeepOptions = {
//   frequency?: number;   // Hz
//   durationMs?: number;  // ms
//   type?: OscType;       // oscillator waveform
//   volume?: number;      // 0..1
//   throttleMs?: number;  // prevent rapid double-beeps
// };

// export async function playBeep(opts: BeepOptions = {}) {
//   const {
//     frequency = 1000,
//     durationMs = 120,
//     type = 'sine',
//     volume = 0.08,
//     throttleMs = 150,
//   } = opts;

//   const now = Date.now();
//   if (now - lastBeepAt < throttleMs) return; // avoid duplicates
//   lastBeepAt = now;

//   const c = ensureCtx();
//   if (c.state !== 'running') {
//     try {
//       await c.resume();
//     } catch {
//       /* noop */
//     }
//   }

//   const osc = c.createOscillator();
//   const gain = c.createGain();

//   osc.type = type;
//   osc.frequency.value = frequency;
//   gain.gain.value = volume;

//   osc.connect(gain).connect(c.destination);

//   const t0 = c.currentTime;
//   // short fade in/out to prevent clicks
//   gain.gain.setValueAtTime(0, t0);
//   gain.gain.linearRampToValueAtTime(volume, t0 + 0.01);
//   gain.gain.linearRampToValueAtTime(0, t0 + durationMs / 1000);

//   osc.start(t0);
//   osc.stop(t0 + durationMs / 1000);
// }


// Local waveform type (avoids depending on DOM lib for OscillatorType)
type OscType = 'sine' | 'square' | 'sawtooth' | 'triangle';

let ctx: AudioContext | undefined;
let lastBeepAt = 0;

function ensureCtx(): AudioContext {
  if (!ctx) {
    const AC: any = (window as any).AudioContext || (window as any).webkitAudioContext;
    ctx = new AC() as AudioContext;
  }
  return ctx!;
}

/** Call on a user gesture (mousedown/click/touchstart) before trying to play audio */
export async function unlockAudio(): Promise<void> {
  try {
    const c = ensureCtx();
    if (c.state !== 'running') {
      await c.resume();
    }
  } catch {
    /* noop */
  }
}

export type BeepOptions = {
  frequency?: number;   // Hz
  durationMs?: number;  // ms
  type?: OscType;       // oscillator waveform
  volume?: number;      // 0..1
  throttleMs?: number;  // prevent rapid double-beeps
};

export async function playBeep(opts: BeepOptions = {}) {
  const {
    frequency = 1000,
    durationMs = 120,
    type = 'sine',
    volume = 0.08,
    throttleMs = 120,
  } = opts;

  const now = Date.now();
  if (now - lastBeepAt < throttleMs) return; // avoid duplicates
  lastBeepAt = now;

  const c = ensureCtx();
  if (c.state !== 'running') {
    try { await c.resume(); } catch { /* noop */ }
  }

  const osc = c.createOscillator();
  const gain = c.createGain();

  osc.type = type;
  osc.frequency.value = frequency;
  gain.gain.value = volume;

  osc.connect(gain).connect(c.destination);

  const t0 = c.currentTime;
  // short fade in/out to prevent clicks
  gain.gain.setValueAtTime(0, t0);
  gain.gain.linearRampToValueAtTime(volume, t0 + 0.01);
  gain.gain.linearRampToValueAtTime(0, t0 + durationMs / 1000);

  osc.start(t0);
  osc.stop(t0 + durationMs / 1000);
}

/**
 * Deflection/bounce tone used when PTT is rejected (e.g., channel busy).
 * Two quick descending beeps: 1kHz→700Hz glide, then 700Hz→500Hz glide.
 */
export async function playBounce() {
  await playBeep({
    frequency: 400,
    durationMs: 90,
    type: 'sine',
    volume: 0.08,
    throttleMs: 120,
  })
}